import { getQueryParams } from 'V2/Utilities/GetQueryParams';

export type ApplySessionParams = {
  appId?: string;
  clickId?: string;
  applicationNotFound: boolean;
};

/**
 * Attribution-bridge params. `auth_token` is deliberately ignored: the session is the applicant_auth
 * cookie that reznor set on the /attribution_link redirect (DLC-1725).
 */
export const readApplySessionParams = (search: string): ApplySessionParams => {
  const { id, click_id, application_not_found } = getQueryParams(search);
  return {
    appId: id,
    clickId: click_id,
    applicationNotFound: application_not_found === 'true',
  };
};

/** Per-tab application context. Drops any legacy URL token so the header path is never used for this session. */
export const persistApplySession = ({
  appId,
  clickId,
}: {
  appId: string;
  clickId: string;
}) => {
  sessionStorage.setItem('appId', appId);
  sessionStorage.setItem('clickId', clickId);
  sessionStorage.removeItem('authToken');
  sessionStorage.removeItem('marketingId');
};

export const clearApplySession = () => {
  sessionStorage.removeItem('appId');
  sessionStorage.removeItem('authToken');
};
